import _ from "lodash"
import PropTypes from "prop-types"
import React, {Fragment} from "react"
import { NavLink } from "react-router-dom"
import shop from "shop/shop"
import app from "app.controller";
import { Button } from "elemental-react16"
import Collapsible                                                                    from 'react-collapsible';
import { Icon } from "semantic-ui-react"
import {Link} from "react-router-dom"

const NavigationCategories = ( { categories } ) => {

  const addLink = function ( category, level ) {
    let children = _.map( category.children, subcat => addLink( subcat, level + 1 ) )
    let parents = getParents( category )
    let parentSegment = (category.parent) ? `/${parents.join( "/" )}` : ""
    let to = `/collection${parentSegment}/${category.map_id}/`
    // if ( !category.active ) return <div key={category.map_id} className={"black-40"}>[OFF] {category.desc.short_des}</div>
    if ( !category.active ) return null
    if ( category.isHidden ) return null
    return (<Fragment key={category.map_id}>

      <div className="fw7" style={{marginLeft: "20px",marginRight: "20px",}} key={category.map_id}>
                      <NavLink
                        className={` level-${level} cat-${category.map_id}`}
                        // activeClassName="active"
                        to={to} >
                          <table>
                            <colgroup>
                              <col width="90%"/>
                              <col width="10%"/>
                            </colgroup>
                            <tbody>
                              <tr>
                            <td onClick={app.sidebarLeft.close.dispatch}>
                            {category.desc.short_des}
                            </td>
                            <td>
                            {children.length > 0 && <Button as={Link} className="buttonNavigationSidebar" to={to} primary  ><Icon className="arrow down"></Icon></Button>}
                            </td>
                          </tr></tbody>
                          </table>

                        {/*<span className="red">({category.sort})</span>*/}
                        
                      </NavLink>

            {children.length >= 1 && <div className={`sub sub-${level}`}>{children}</div>}
          </div>
    </Fragment>)
  }
  let cats = _.map( categories, cat => addLink( cat, 0 ) )
  return (
    <div>
      {cats}
    </div>
  )
}

NavigationCategories.propTypes = {
  categories: PropTypes.any
}

const getParents = ( category ) => {
  let ttl = 10
  let parents = []
  while (category && category.parent && ttl--) {
    parents.push( category.parent )
    category = shop.categoriesById.get( category.parent )
  }
  return parents.reverse()
}


export default NavigationCategories


// WEBPACK FOOTER //
// ./src/theme/hvz/components/Navigation/NavigationCategories.js